import React from 'react';
import styles from './styles.module.scss';
import { Card } from 'components/cards/Card';

export const MediumCard = ({ children }) => (
  <Card
    radius="lg"
    className={styles.mediumCard}
  >
    {children}
  </Card>
);
